import { get } from 'lodash-es'
import Vue from 'vue'
import { default as VueDpEcho, Echo } from './vue-dp-echo'
// import { getModule } from './ws-store-module'
import { WS_MODULE, WS_CONSTANTS } from './ws-store-module'
import { initWsStorePlugin } from './ws-store-module/ws-store-plugin'
import APP_CONFIG_CONSTANTS from '@/js/helper/app-config-constants'

export const initWs = ({ appConfig, store }) => {
  // console.log(appConfig)
  // const token = get(appConfig, [
  //   'attributes',
  //   APP_CONFIG_CONSTANTS.MESSAGING_TOKEN,
  //   APP_CONFIG_CONSTANTS.TOKEN,
  // ])
  const wsHost = get(appConfig, [
    APP_CONFIG_CONSTANTS.LINKS,
    APP_CONFIG_CONSTANTS.MESSAGING_CONFIG,
    APP_CONFIG_CONSTANTS.MESSAGING_DOMAIN,
  ])
  const wsPort = get(
    appConfig,
    [
      APP_CONFIG_CONSTANTS.LINKS,
      APP_CONFIG_CONSTANTS.MESSAGING_CONFIG,
      APP_CONFIG_CONSTANTS.MESSAGING_WS_PORT,
    ],
    6001,
  )

  if (!wsHost) {
    console.log('No wsHost')
    return
  }

  const isSSL = window.location.protocol === 'https:'

  const options = {
    broadcaster: 'pusher',
    key: 'dpws',
    cluster: 'dpws',
    wsHost,
    wsPort,
    wssPort: wsPort === '80' ? 443 : wsPort,
    forceTLS: isSSL,
    disableStats: true,
    authEndpoint: `${window.location.protocol}//${wsHost}/broadcasting/auth`,
    enabledTransports: isSSL ? ['wss', 'ws'] : ['ws'],
  }

  // if (token) {
  //   options.auth = {
  //     headers: { Authorization: `Bearer ${token}` },
  //   }
  // }

  Vue.use(VueDpEcho, options, store)
  initWsStoreModule(store)
}

const initWsStoreModule = store => {
  if (!store.hasModule(WS_CONSTANTS.MODULE_ID)) {
    store.registerModule(WS_CONSTANTS.MODULE_ID, WS_MODULE)
  }
  initWsStorePlugin({ store, Echo })
}

// import Echo from 'laravel-echo'
// import { get } from 'lodash-es'
// window.Pusher = require('pusher-js')

// const notConnected = ['disconnected', 'unavailable']

// let ws
// // let listenerAdded = false

// const reconnect = () => {
//   try {
//     // ws.connector.pusher.connection.unbind_all()
//   } catch (e) {
//     console.log(e)
//   }
//   ws.connect()
// }

// const connect = () => {
//   // if (ws) {
//   //   console.log('disconnect')
//   //   ws.connector.pusher.connection.unbind('state_change')
//   //   ws.disconnect()
//   // }
//   // if (get(ws, ['connector', 'pusher'])) {
//   //   console.log('pusher.unbind_all')
//   //   ws.connector.pusher.unbind_all()
//   //   ws.connector.pusher.connection.unbind_all()
//   // }

//   console.log(ws?.connector?.pusher?.connection?.state)
//   if (!ws?.connector?.pusher?.connection?.state) {
//     console.log('no state')
//     ws = new Echo({
//       broadcaster: 'pusher',
//       key: 'local',
//       wsHost: 'messaging.dealerportal.test',
//       wsPort: 6001,
//       forceTLS: false,
//       disableStats: true,
//     })

//     ws.connector.pusher.connection.bind('state_change', function (states) {
//       const prevState = states.previous
//       const currState = states.current
//       console.log({ prevState, currState })
//       // if (currState === 'connected' && !listenerAdded) {
//       //   ws.connector.pusher.connection.unbind_all()
//       // }

//       if (notConnected.includes(currState)) {
//         setTimeout(() => {
//           console.log('try to connect')
//           reconnect()
//         }, 5000)
//       }
//     })
//     ws.channel('announcements').listen('.Announcement', e => {
//       console.log('Announcement')
//       console.log(e)
//     })
//   } else {
//     ws.connect()
//   }
// }

// export const getWebSocketConnection = appConfig => {
//   connect()
// }
